// Shared helpers for match tooltips and tables
export function formatSetsScore(sets) {
  if (!sets || !Array.isArray(sets)) return '';
  return sets.map(set => `${set.home || 0}:${set.away || 0}`).join(', ');
}

// коэффициент по партиям (setsWon / setsLost), округлено до сотых, при 0 проигранных -> ∞, при 0/0 -> '—'
export function formatRatio(wins, losses) {
  const w = Number(wins) || 0;
  const l = Number(losses) || 0;
  if (l === 0) return w > 0 ? '∞' : '—';
  const ratio = w / l;
  if (!isFinite(ratio) || isNaN(ratio)) return '—';
  return ratio.toFixed(2);
}

